import React, { Component } from "react";
import Signup from "./Signup";
import AuthServiceClient from "../../Services/Clients/AuthServiceClient";
import {
	setSignupPath,
	storeAuthCode,
	unsetAuthCode,
	getFromStorage,
	putInStorage,
} from "../../Services/StorageService";
import Toast from "../ModalMessages/Toast";
import { activateEnterpriseBots } from "../../Services/BotsService";
import { updateLastLoggedInDomain } from "../../Services/UserService";
import {FRONTM_LANDING, FRONTM_DOMAIN, HELPER_MESSAGE, ACTIVATE_ENTERPRISE_BOTS_ERROR_CODES, VOYAGER_VOICE_AUTH_CODE, ONSHIP_SIGNUP_LANDING, ONSHIP_LANDING, THURAYA_T2M_SIGNUP_LANDING, THURAYA_T2M_LANDING, THURAYA_LANDING, THURAYA_DOMAIN, ONECARE_PROD_URL_NEW, ONECARE_PROD_URL, ONECARE_LANDING, VIKAND_PROD_URL, VIKAND_HEALTH_PROD_URL, VIKAND_CONNECT_PROD_URL, VIKAND_NEW_STAGE_URL, VIKAND_LANDING, VIKAND_DIRECT_LANDING, THURAYA_T2M_PROD_URL, STAGE_8_THURAYA_URL, ONSHIP_PROD_URL, ONSHIP_STAGE_URL, ONSHIP_NEW_STAGE2_URL, STATIONSATCOM_PROD_URL, STATION_SATCOM_LANDING, SIGMA_PROD_URL, SIGMA_LANDING, PIVOTEL_PROD_URL, PIVOTEL_LANDING, STATION_ONE_URL, STATION_ONE_LANDING, STATION_ONE_STAGE_URL, INTELSAT_STAGE_URL, INTELSAT_PROD_URL, INTELSAT_LANDING, THURAYA_PROD_URL, STATION_ONE_SIGNUP_LANDING} from '../../Utils/Constants';
import Landing from "./CustomLanding/Landing";
import appType from "../../Utils/ApiConfig";
import CookiePolicy from "../App/CookiePolicy";
import history from "../../Services/History";
import OnshipSignupView from "./OnshipSignupView";
import StationOneSignupView from "./StationOneSignupView";
import SattracklandSignupView from "./SattracklandSignupView";
import { loadAllDomainsListInLFStorage } from "../../Services/LFStorage";
import Notify from "../ModalMessages/ToastNotif";
import HomeContainer from "../../Containers/HomeContainer";

const https = 'https://';
class SignupView extends Component {
	constructor(props) {
		super(props);
		this.state = {
			submitting: false,
			email: "",
			password: "",
			corporateSignup: false,
			landingPath: null,
		};
	}

	getCurrentDomainPaths = (currentHostName) => {
        switch (currentHostName) {
            case ONECARE_PROD_URL_NEW:
            case ONECARE_PROD_URL:
            case "stage5.frontm.com":
                return ONECARE_LANDING;
    
            case VIKAND_PROD_URL:
            case VIKAND_HEALTH_PROD_URL:
            case VIKAND_CONNECT_PROD_URL:
            case VIKAND_NEW_STAGE_URL:
            case "stage2.frontm.com":
                return VIKAND_LANDING;

			case INTELSAT_STAGE_URL:
            case INTELSAT_PROD_URL:
                return INTELSAT_LANDING;
    
            case THURAYA_T2M_PROD_URL:
            case "stage3.frontm.com":
                return THURAYA_T2M_SIGNUP_LANDING;
            
            case STAGE_8_THURAYA_URL:
                 return THURAYA_LANDING
    
            case ONSHIP_PROD_URL:
            case ONSHIP_STAGE_URL:
            case ONSHIP_NEW_STAGE2_URL:
                return ONSHIP_LANDING, ONSHIP_SIGNUP_LANDING;
    
            case STATIONSATCOM_PROD_URL:
            case "stage6.frontm.com":
                return STATION_SATCOM_LANDING;
    
            case SIGMA_PROD_URL:
                return SIGMA_LANDING;
    
            case PIVOTEL_PROD_URL:
            case "stage7.frontm.com":
                return PIVOTEL_LANDING;
            
            // case STATION_ONE_URL:
            // case STATION_ONE_STAGE_URL:
            //     return STATION_ONE_LANDING;
            default:
                return [""];
        };
    };

	componentDidMount() {
		if ([https + THURAYA_PROD_URL, https + STAGE_8_THURAYA_URL].includes(window.location.origin)) {
			setSignupPath(THURAYA_LANDING);
			this.setState({
				corporateSignup: true,
				landingPath: THURAYA_LANDING,
			});
		} else {
			const pathName = this.props?.location?.pathname;
			if (pathName !== FRONTM_LANDING) {
				if (pathName === ONSHIP_SIGNUP_LANDING) {
					setSignupPath(ONSHIP_LANDING);
				} else if (pathName === STATION_ONE_SIGNUP_LANDING) {
					setSignupPath(STATION_ONE_LANDING);
				} else {
					setSignupPath(pathName ? pathName : this.getCurrentDomainPaths(window.location.hostname));
				}
				this.setState({
					corporateSignup: true,
					landingPath: pathName ? pathName : this.getCurrentDomainPaths(window.location.hostname),
				});
			}
		}
	}


	activateEnterpriseBotAndSetLastLoggedInDomain = (authCode) => {
		let message = null;
		return activateEnterpriseBots(authCode).then((activateResponse) => {
			// console.log("activateEnterprise ", activateResponse);

			let { content, error, errorMessage } = activateResponse;
			if (error !== 0 || content.length === 0) {
				message = errorMessage
					? errorMessage + ". " + HELPER_MESSAGE
					: HELPER_MESSAGE;
				return updateLastLoggedInDomain(FRONTM_DOMAIN).then(() => {
					if (message) {
						throw new Error(message);
					}
				});
			} else {
				const domains = content;
				let corporateDomainList = domains.filter((domain) => {
					return domain.userDomain !== FRONTM_DOMAIN;
				});
				loadAllDomainsListInLFStorage(corporateDomainList);
				let corporateDomain =
					corporateDomainList.length > 0
						? corporateDomainList[0].userDomain
						: "";
				if (corporateDomain.length === 0) {
					message = HELPER_MESSAGE;
					corporateDomain = FRONTM_DOMAIN;
				}

				// console.log("domains ======== ", corporateDomain, corporateDomainList);

				return updateLastLoggedInDomain(corporateDomain).then(() => {
					if (message) {
						throw new Error(message);
					}
				});
			}
		});
	};

	onLoginSuccess = (message) => {
		let { location } = this.props;
		let query = null;
		if (location && location.search) {
			query = location.search;
		}

		if (query) {
			let path = query.substring(10, query.length);
			history.push(path);
		} else {
			if (this.state.corporateSignup) {
				// console.log("corporateSignup ", this.state.corporateSignup);

				this.activateEnterpriseBotAndSetLastLoggedInDomain(
					VOYAGER_VOICE_AUTH_CODE
				)
					.catch((error) => {
						console.log("error occured :: ", error.message);
						let errMsg = error ? error.message : "";
						if (
							errMsg &&
							ACTIVATE_ENTERPRISE_BOTS_ERROR_CODES.indexOf(errMsg) !== -1
						) {
							message = errMsg + ". " + HELPER_MESSAGE;
						} else {
							message = HELPER_MESSAGE;
						}
					})
					.finally(() => {
						console.log("move to bot page");

						unsetAuthCode();
						history.push({
							pathname: "/app/home",
							state: { routingFrom: "signup" },
						});
					});
			}
		}
	};

	createUser = (formData, landingPath) => {
		const { email, password, name, authCode } = formData;

		const doSignUpAuth = (signupObj) => {
			AuthServiceClient.doSignUp(signupObj)
				.then((response) => {
					console.log("Manish signupResponse :: ", response);
					this.handleSuccess(response);
				})
				.then(() =>
					this.setState({
						submitting: false,
					})
				)
				.catch((error) => this.handleError(error));
		}

		this.setState({
			submitting: true,
			email,
			password,
			authCode,
		});
		let typeOfApp = appType;
		let domain = landingPath === THURAYA_LANDING ? THURAYA_DOMAIN : ""

		let signupObj = {};

		if (typeOfApp) {
			signupObj = {
				email,
				password,
				userName: `${name}`,
				appType: typeOfApp,
			};
		} else if (landingPath && landingPath === THURAYA_LANDING) {
			signupObj = {
				email,
				password,
				userName: `${name}`,
				authCode
			};
		} else {
			signupObj = {
				email,
				password,
				userName: `${name}`,
			};
		}

		if (domain !== "" && domain === THURAYA_DOMAIN) {
			AuthServiceClient.verifyLicenseCode(authCode, THURAYA_DOMAIN)
				.then(response => {
					if (response && response.data === "Success") {
						doSignUpAuth(signupObj)
					} else {
						Toast({
							type: "error",
							message: `License key is incorrect. Please enter the right key`,
						});
					}
				})
				.catch({})
		} else {
			doSignUpAuth(signupObj)
		}
	};

	handleSuccess = (data) => {
		if (data.success) {
			let authCode = this.state.authCode;
			authCode && storeAuthCode(authCode, this.state.email);
			Toast({
				type: "success",
				message:
					"User created successfully! Please verify using the Code that has been emailed.",
				onClose: () =>
					history.push({
						pathname: "/verify",
						state: {
							email: this.state.email,
							password: this.state.password,
							authCode: this.state.authCode,
						},
					}),
				autoClose: 5000,
			});
		} else {
			Toast({
				type: "error",
				message: data.message,
			});
		}
	};
	handleError = (error) => {
		Toast({
			type: "error",
			message: error.message || "Error occurred while creating user",
		});
	};

	acceptCookiePolicy = () => {
		putInStorage("cookiePolicyAccepted", true);
		this.setState({ cookiePolicyAccepted: true });
	};

	render() {
		const { landingPath, corporateSignup } = this.state;
		let landingComponent = null;
		let cookiePolicyAccepted = getFromStorage("cookiePolicyAccepted");

		if (corporateSignup) {
			if (landingPath === ONSHIP_SIGNUP_LANDING) {
				landingComponent = (
					<OnshipSignupView
						{...this.props}
						createUser={this.createUser}
						corporateSignup={this.state.corporateSignup}
						landingPath={landingPath}
					/>
				);
			} else if (landingPath === THURAYA_T2M_SIGNUP_LANDING) {
				landingComponent = (
					<SattracklandSignupView
						{...this.props}
						createUser={this.createUser}
						corporateSignup={this.state.corporateSignup}
						landingPath={landingPath}
					/>
				);
			} else if (landingPath === STATION_ONE_SIGNUP_LANDING) {
				landingComponent = (
					<StationOneSignupView
						{...this.props}
						createUser={this.createUser}
						corporateSignup={this.state.corporateSignup}
						landingPath={landingPath}
					/>
				);
			} else {
				landingComponent = (
					<Landing
						{...this.props}
						onLogin={this.onLoginSuccess}
						createUser={this.createUser}
						corporateSignup={this.state.corporateSignup}
						landingPath={landingPath}
					/>
				);
			}
		} else {
			landingComponent = (
				<div className="greenBackground">
					<Signup
						{...this.props}
						onLogin={this.onLoginSuccess}
						createUser={this.createUser}
						corporateSignup={this.state.corporateSignup}
					/>
				</div>
			);
		}

		if([ONSHIP_NEW_STAGE2_URL].includes(window.location.hostname) && window.location.pathname === VIKAND_LANDING){
			return (
				<HomeContainer />
			)
		}

		return (
			<div
				className="page-wrapper d-flex flex flex-column container-fluid full-height"
				id="page-wrapper"
				style={{ padding: "0px" }}
			>
				{landingComponent}
				{!cookiePolicyAccepted && (
					<div
						style={{
							position: "fixed",
							bottom: 0,
							width: "100%",
						}}
					>
						<CookiePolicy acceptCookiePolicy={this.acceptCookiePolicy} />
					</div>
				)}
			</div>
		);
	}
}

export default SignupView;
